/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') {
    ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
    if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
            attribute = '';
        }
    }
    return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
    // alert('There are now ' + cart.item_count + ' items in the cart.');

    //console.log(cart);
};

ShopifyAPI.updateCartNote = function (note, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/update.js',
            data: 'note=' + attributeToString(note),
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeUpdateCartNote.ajaxCart', note);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        alert(data.message + '(' + data.status + '): ' + data.description);
    }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = async function (form, callback, errorCallback) {
    let form_array = jQuery(form).serializeArray(),
        shopify_product_id = null,
        buy_one = false,
        product_purchasable = true,
        qty = 0;

    $.each(form_array, function () {
        if (this.name === 'shopify_product_id') {
            shopify_product_id = this.value;
        }

        if (this.name === 'buy_one') {
            buy_one = true;
        }

        if(this.name === 'quantity'){
            qty = Number(this.value);
        }
    });

    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/add.js',
            data: jQuery(form).serialize(),
            dataType: 'json',
            beforeSend: function (jqxhr, settings) {
                $body.trigger('beforeAddItem.ajaxCart', form);
            },
            success: function (line_item) {
                if ((typeof callback) === 'function') {
                    callback(line_item, form);
                }
                else {
                    ShopifyAPI.onItemAdded(line_item, form);
                }
                $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
            },
            error: function (XMLHttpRequest, textStatus) {
                if ((typeof errorCallback) === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                }
                else {
                    ShopifyAPI.onError(XMLHttpRequest, textStatus);
                }
                $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
            }
        };

    if (buy_one) {
        let in_cart = await ShopifyAPI.isItemInCart(shopify_product_id);

        if (in_cart || 1 < qty) {
            product_purchasable = false;
        }
    }

    if (product_purchasable) {
        jQuery.ajax(params);
    } else {
        $('#product_already_bought_modal').remodal().open();
    }
};

ShopifyAPI.isItemInCart = async function (item) {
    let in_cart = false;

    await jQuery.getJSON('/cart.js', function (cart, textStatus) {
        $.each(cart.items, function () {
            if (this.product_id === Number(item)) {
                in_cart = true;
            }
        });
    });

    return in_cart;
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
    $(document.body).trigger('beforeGetCart.ajaxCart');
    jQuery.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        }
        else {
            ShopifyAPI.onCartUpdate(cart);
        }
        $(document.body).trigger('afterGetCart.ajaxCart', cart);
    });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
    var $body = $(document.body),
        params = {
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            beforeSend: function () {
                $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
            },
            success: function (cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                }
                else {
                    ShopifyAPI.onCartUpdate(cart);
                }
                $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
            },
            error: function (XMLHttpRequest, textStatus) {
                $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
                ShopifyAPI.onError(XMLHttpRequest, textStatus);
            },
            complete: function (jqxhr, text) {
                $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
            }
        };
    jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {

    'use strict';

    // Public functions
    var init, loadCart;

    // Private general variables
    var settings, isUpdating, $body;

    // Private plugin variables
    var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

    // Private functions
    var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, getProduct,
        applyItemDiscounts, cartCallback, adjustCart, adjustCartCallback,
        createQtySelectors, qtySelectors, validateQty;

    /*============================================================================
      Initialise the plugin and define global options
    ==============================================================================*/
    init = function (options) {

        // Default settings
        settings = {
            formSelector: 'form[action^="/cart/add"]',
            cartContainer: '#CartContainer',
            addToCartSelector: 'input[type="submit"]',
            cartCountSelector: null,
            cartCostSelector: null,
            moneyFormat: '$',
            disableAjaxCart: false,
            enableQtySelectors: true
        };

        // Override defaults with arguments
        $.extend(settings, options);

        // Select DOM elements
        $formContainer = $(settings.formSelector);
        $cartContainer = $(settings.cartContainer);
        $addToCart = $formContainer.find(settings.addToCartSelector);
        $cartCountSelector = $(settings.cartCountSelector);
        $cartCostSelector = $(settings.cartCostSelector);

        // General Selectors
        $body = $(document.body);

        // Track cart activity status
        isUpdating = false;

        // Setup ajax quantity selectors on the any template if enableQtySelectors is true
        if (settings.enableQtySelectors) {
            qtySelectors();
        }

        // Take over the add to cart form submit action if ajax enabled
        if (!settings.disableAjaxCart && $addToCart.length) {

            formOverride();
        }

        // Run this function in case we're using the quantity selector outside of the cart
        adjustCart();
    };

    loadCart = function () {
        $body.addClass('drawer--is-loading');
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    updateCountPrice = function (cart) {
        if ($cartCountSelector) {
            $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

            if (cart.item_count === 0) {
                $cartCountSelector.addClass('hidden-count');
            }
        }
        if ($cartCostSelector) {
            $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
        }

        // Utolsó line item törlése
        if (cart.items.length == 0) {
            renderSmallCartIcon([]);
            $('.ajaxcart__footer').fadeOut();
        }

        // Ingyenes szállításhoz szükséges ár frissítése
        $.get('?section_id=free-shipping-info').then(function (html) {
            var $free_shipping_info_wrapper = $('#product-offer-info-wrapper');

            if ($free_shipping_info_wrapper.length && html) {
                $free_shipping_info_wrapper.html(html);
            }
        });
    };

    formOverride = function () {
        $formContainer.on('submit', function (evt) {
            evt.preventDefault();

            // Add class to be styled if desired
            $addToCart.removeClass('is-added').addClass('is-adding');

            // Remove any previous quantity errors
            $('.qty-error').remove();
            $addToCart.prop('disabled', false);

            if(typeof window.product_bought === 'undefined'){
                ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
            }
        });
    };

    itemAddedCallback = function (product) {
        $addToCart.removeClass('is-adding').addClass('is-added');

        //  mixpanel.track("Added to Cart", {
        //    "name":  product.product_title ,
        //   "variant": product.variant_title,
        //    "qty":product.quantity,
        //    "original_price": Shopify.formatMoney(product.original_price, ""),
        //    "price":Shopify.formatMoney(product.price, "")


        //});

        // ha előtte quick-carttal más termék került a hoverbe, az oldal termékét állítsuk vissza
        if (typeof restoreCartHooverDefault === 'function') {
            restoreCartHooverDefault();
        }

        if (typeof updateSmallCartFromProductForm === 'function') {
            updateSmallCartFromProductForm();
        }

        showSmallCart();
        ShopifyAPI.getCart(cartUpdateCallback);
    };

    itemErrorCallback = function (XMLHttpRequest, textStatus) {
        var data = eval('(' + XMLHttpRequest.responseText + ')');
        $addToCart.removeClass('is-adding is-added');

        if (!!data.message) {
            if (data.status == 422) {
                $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
                $addToCart.prop('disabled', true);
                $('.cart__hover').hide();
            }
        }
    };

    cartUpdateCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);
        buildCart(cart);
    };

    buildCart = function (cart) {
        // Start with a fresh cart div
        $cartContainer.empty();

        // Show empty cart
        if (cart.item_count === 0) {
            $cartContainer
                .append('<p>' + "Your cart is currently empty" +'</p>');
            cartCallback(cart);
            return;
        }

        // Handlebars.js cart layout
        var items = [],
            item = {},
            data = {},
            source = $("#CartTemplate").html(),
            template = Handlebars.compile(source);
        // Add each item to our handlebars.js data
        $.each(cart.items, function (index, cartItem) {
            // console.log(cartItem);
            /* Hack to get product image thumbnail
             *   - If image is not null
             *     - Remove file extension, add _small, and re-add extension
             *     - Create server relative link
             *   - A hard-coded url of no-image
            */
            if (cartItem.image != null) {
                var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
            } else {
                var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
            }

            // Create item's data object and add to 'items' array
            item = {
                id: cartItem.product_id,
                key: cartItem.key,
                line: index + 1, // Shopify uses a 1+ index in the API
                url: cartItem.url,
                img: prodImg,
                name: cartItem.product_title,
                handle: cartItem.handle,
                properties: cartItem.properties,
                variation: cartItem.variant_title,
                itemQty: cartItem.quantity,
                originalLinePrice: cartItem.original_line_price,
                linePrice: cartItem.line_price,
                formattedPrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
                discountsApplied: false,
                discountType: ''
            };

            applyItemDiscounts(item);

            items.push(item);

        });

        data = {
            items: items,
            note: cart.note,
            totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
        }


        $cartContainer.append(template(data));
        cartCallback(cart);

        //Az uj kiskosár elkészitése
        renderSmallCartIcon(data.items);

    };
    /**
     * A termék "properties" értékeket, ahhoz hogy megtudjuk mondani milyen kedveményről van szó a LineItem Script rakja rá
     * Ha compare_at_price van azt a termék oldaon "hidden-input" rakja rá ugyancsak property-ként
     */
    applyItemDiscounts = function (item) {
            let discount_type_text = '';
            let discount_applied = false;

            if (null !== item.properties) {
                if ('on_sale' in item.properties) {
                    discount_applied = true;
                    discount_type_text = 'Sale price';
                }

                if ('loyalty_discount' in item.properties) {
                    if (item.originalLinePrice !== item.linePrice) {
                        discount_applied = true;
                      if (item.properties.have_introprice) {
                        discount_type_text = 'Introductory price';
                      } else {
                        discount_type_text = 'Discounted loyalty price';
                      }
                    }
                }

                if ('lifetsyle_package_discount' in item.properties) {
                    discount_applied = true;
                    discount_type_text = 'Lifestyle Program Price';
                }
            }

            item.discountType = discount_type_text;
            item.discountsApplied = discount_applied;

    };

    cartCallback = function (cart) {
        $body.removeClass('drawer--is-loading');
        $body.trigger('afterCartLoad.ajaxCart', cart);

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }

        var $cart_footer = $('.ajaxcart__footer');
        var $modal_footer = $('#CartDrawer .fix');
        var $title_quantity = $('#CartDrawer .drawer__title .cart-quantity');

        $cart_footer.remove();
        if (!$('#CartDrawer .fix .ajaxcart__footer').length) {
            $modal_footer.prepend($cart_footer);
        }

        $title_quantity.text(cart.item_count);
    };

    adjustCart = function () {
        // Delegate all events because elements reload with the cart

        // Add or remove from the quantity
        $body.on('click', '.ajaxcart__qty-adjust', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                $qtySelector = $el.siblings('.ajaxcart__qty-num'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;
                if (qty <= 0) qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });


        $body.on('click touch', '.ajaxcart__removeItem-outer', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = 0;

            var qty = validateQty(qty);


            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });
        // Update quantity based on input on change
        $body.on('change', '.ajaxcart__qty-num', function () {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                line = $el.data('line'),
                qty = parseInt($el.val().replace(/\D/g, ''));

            var qty = validateQty(qty);

            // If it has a data-line, update the cart
            if (line) {
                updateQuantity(line, qty);
            }
        });

        // Prevent cart from being submitted while quantities are changing
        $body.on('submit', 'form.ajaxcart', function (evt) {
            if (isUpdating) {
                evt.preventDefault();
            }
        });

        // Highlight the text when focused
        $body.on('focus', '.ajaxcart__qty-adjust', function () {
            var $el = $(this);
            setTimeout(function () {
                $el.select();
            }, 50);
        });

        function updateQuantity(line, qty) {
            isUpdating = true;

            // Add activity classes when changing cart quantities
            var $row = $('.ajaxcart__product[data-line="' + line + '"]').addClass('is-loading');

            if (qty === 0) {
                $row.slideUp();
            }

            // Slight delay to make sure removed animation is done
            setTimeout(function () {
                ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
        }

        // Save note anytime it's changed
        $body.on('change', 'textarea[name="note"]', function () {
            var newNote = $(this).val();

            // Update the cart note in case they don't click update/checkout
            ShopifyAPI.updateCartNote(newNote, function (cart) {
            });
        });
    };

    adjustCartCallback = function (cart) {
        // Update quantity and price
        updateCountPrice(cart);

        // Reprint cart on short timeout so you don't see the content being removed
        setTimeout(function () {
            isUpdating = false;
            ShopifyAPI.getCart(buildCart);
        }, 150)
    };

    createQtySelectors = function () {
        // If there is a normal quantity number field in the ajax cart, replace it with our version
        if ($('input[type="number"]', $cartContainer).length) {
            $('input[type="number"]', $cartContainer).each(function () {
                var $el = $(this),
                    currentQty = $el.val();

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#AjaxQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });
        }
    };

    qtySelectors = function () {
        // Change number inputs to JS ones, similar to ajax cart but without API integration.
        // Make sure to add the existing name and id to the new input element
        var numInputs = $('input[type="number"]');

        if (numInputs.length) {
            numInputs.each(function () {
                var $el = $(this),
                    currentQty = $el.val(),
                    inputName = $el.attr('name'),
                    inputId = $el.attr('id');

                var itemAdd = currentQty + 1,
                    itemMinus = currentQty - 1,
                    itemQty = currentQty;

                var source = $("#JsQty").html(),
                    template = Handlebars.compile(source),
                    data = {
                        key: $el.data('id'),
                        itemQty: itemQty,
                        itemAdd: itemAdd,
                        itemMinus: itemMinus,
                        inputName: inputName,
                        inputId: inputId
                    };

                // Append new quantity selector then remove original
                $el.after(template(data)).remove();
            });

            // Setup listeners to add/subtract from the input
            $('.js-qty__adjust').on('click', function () {
                var $el = $(this),
                    id = $el.data('id'),
                    $qtySelector = $el.siblings('.js-qty__num'),
                    qty = parseInt($qtySelector.val().replace(/\D/g, ''));

                var qty = validateQty(qty);

                // Add or subtract from the current quantity
                if ($el.hasClass('js-qty__adjust--plus')) {
                    qty += 1;
                } else {
                    qty -= 1;
                    if (qty <= 1) qty = 1;
                }

                // Update the input's number
                $qtySelector.val(qty);
            });
        }
    };

    validateQty = function (qty) {
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
        } else {
            // Not a number. Default to 1.
            qty = 1;
        }
        return qty;
    };

    module = {
        init: init,
        load: loadCart
    };

    return module;

}(ajaxCart || {}, jQuery));
